export const channelsOneText = [
  'Same Day/Scheduled Deliveries',
  'Local & International Deliveries',
  'Dedicated Customer Support',
  'Returns Management',
  'White Glove & Contactless Deliveries',
  'Easy to Use & Friendly Service',
];
